import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { eventSender } from 'Lib/event-sender/event-sender';
import 'Vendor/owlcarousel/owl.carousel.min';

const $block = $('.brands:not(.brands_simple)');

function initLoaderImages($el) {
    onScreen($el, loadSrcOrBg);
}

function sendEventGA4($el, event) {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: event,
        eventCategory: $('title').text().trim(),
        eventLabel: `Наши бренды${event === 'click' ? ` - ${$el.attr('href')}` : ''}`,
    });
}

if ($block.length) {
    initLoaderImages($block.find('.brands__dlogos-link'));
}

onScreen($('.brands'), ($el) => {
    sendEventGA4($el, 'view');
}, 0, 0, 0.8);

$('.brands__dlogos-link').on('click', function () {
    sendEventGA4($(this), 'click');
});